'use strict';

/**
 *  Copyright (c) 2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the license found in the
 *  LICENSE-examples file in the root directory of this source tree.
 */

// The primary React component to use.
module.exports = require('./components/GraphiQL').GraphiQL;


/*****************
 ** WEBPACK FOOTER
 ** ./~/graphiql/dist/index.js
 ** module id = 431
 ** module chunks = 0
 **/